import { defineMessages } from "react-intl";

const PREFIX = "Subscriptions.DeleteSubscriptionDialog";
export default defineMessages({
  title: {
    id: `${PREFIX}.title`,
    defaultMessage: "Remove from subscriptions",
  },
  contentText: {
    id: `${PREFIX}.contentText`,
    defaultMessage: 'Are you sure you want to remove the "{subscriptionItemName}" from Subscriptions?',
  },
  remove: {
    id: `${PREFIX}.remove`,
    defaultMessage: "Remove",
  },
  cancel: {
    id: `${PREFIX}.cancel`,
    defaultMessage: "Cancel",
  },
});
